<template>
    <b-card no-body>
        <b-overlay :show="getting">
            <!-- Üst Bölüm: Sol (filtre, dar) | Sağ (özet kutucuklar, geniş) -->
            <div class="p-1 row align-items-center">
                <!-- Sol Kolon: Filtreler -->
                <div class="col-md-3 mb-1 mb-md-0">
                    <div class="mb-1">
                        <select class="form-control bg-img-none" v-model="year">
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                    <div class="mb-1">
                        <v-select-list
                            v-model="employee"
                            :options="employees"
                            label="Combine"
                            v-on:search="searchEmployees"
                            placeholder="Personel"
                            :loading="employeeLoading"
                        ></v-select-list>
                    </div>
                    <div>
                        <button class="btn btn-success btn-block" v-on:click="get" :disabled="employee == null">Sorgula</button>
                    </div>
                </div>

                <!-- Sağ Kolon: Özet Kutucuklar -->
                <div class="col-md-9">
                    <!-- Bakiye -->
                    <div class="row">
                        <div class="col-12 mb-1">
                            <v-stats-box text="Bakiye" variant="secondary" icon="account_balance_wallet" :value="balanceStr" :center="true"></v-stats-box>
                        </div>
                    </div>
                    <!-- Hesap Dağılımı: Kart / Banka 1 / Banka 2 / Toplam -->
                    <div class="row">
                        <div class="col-6 col-xl-3 mb-1 mb-xl-0">
                            <v-stats-box text="Kart" variant="info" icon="credit_card" :value="projectDistribution.Kart"></v-stats-box>
                        </div>
                        <div class="col-6 col-xl-3 mb-1 mb-xl-0">
                            <v-stats-box text="Banka 1" variant="warning" icon="account_balance" :value="projectDistribution.Banka1"></v-stats-box>
                        </div>
                        <div class="col-6 col-xl-3 mb-1 mb-xl-0">
                            <v-stats-box text="Banka 2" variant="primary" icon="account_balance" :value="projectDistribution.Banka2"></v-stats-box>
                        </div>
                        <div class="col-6 col-xl-3 mb-1 mb-xl-0">
                            <v-stats-box text="Toplam" variant="dark" icon="summarize" :value="projectDistribution.Toplam"></v-stats-box>
                        </div>
                    </div>
                </div>
            </div>

            <!-- T-Cetveli Tablosu -->
            <div class="table-responsive">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th class="text-nowrap">Tarih</th>
                            <th class="text-nowrap">Açıklama</th>
                            <th class="text-nowrap">Referans No</th>
                            <th class="text-nowrap">Tip</th>
                            <th class="text-nowrap text-right text-danger">Borç (TL)</th>
                            <th class="text-nowrap text-right text-success">Alacak (TL)</th>
                            <th class="text-nowrap text-center">İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in details" :key="i">
                            <td class="text-nowrap">{{ $safe(d, "DueDateStr") || "-" }}</td>
                            <td class="text-nowrap">{{ $safe(d, "Description") || "-" }}</td>
                            <td class="text-nowrap">{{ $safe(d, "RefCode") }}</td>
                            <td class="text-nowrap">{{ $safe(d, "ProjectType") }}</td>
                            <!-- BORÇ sütunu: Positive == false ise tutar göster -->
                            <td class="text-nowrap text-right font-weight-bolder text-danger">
                                {{ !d.Positive ? $safe(d, "AmountStr") : "" }}
                            </td>
                            <!-- ALACAK sütunu: Positive == true ise tutar göster -->
                            <td class="text-nowrap text-right font-weight-bolder text-success">
                                {{ d.Positive ? $safe(d, "AmountStr") : "" }}
                            </td>
                            <td class="text-nowrap text-center">
                                <!-- Kilit: Borç VE IsLocked == true ise disabled -->
                                <span
                                    v-b-tooltip.hover
                                    :title="isRowLocked(d) ? 'İşlem yazılmış borç kaydı değiştirilemez' : 'Düzenle'"
                                >
                                    <button
                                        class="btn btn-sm btn-primary"
                                        :disabled="isRowLocked(d)"
                                        v-on:click="openEditModal(d)"
                                    >
                                        <feather-icon icon="EditIcon" size="14" />
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr v-if="(details || []).length === 0">
                            <td colspan="7" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-overlay>

        <!-- Düzenleme Modalı -->
        <b-modal
            id="edit-balance-modal"
            title="Kayıt Düzenle"
            ok-title="Kaydet"
            cancel-title="İptal"
            :ok-disabled="saving"
            v-on:ok.prevent="saveEdit"
            v-on:hidden="resetEditForm"
        >
            <b-overlay :show="saving">
                <div class="form-group">
                    <label class="font-weight-bold">Tutar (TL)</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model.number="editForm.Amount"
                        min="0.01"
                        step="0.01"
                        placeholder="Tutar giriniz"
                    />
                </div>
                <div class="form-group">
                    <label class="font-weight-bold">Vade Tarihi</label>
                    <input
                        type="date"
                        class="form-control"
                        v-model="editForm.DueDate"
                    />
                </div>
                <div class="form-group">
                    <label class="font-weight-bold">Açıklama</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="editForm.Description"
                        placeholder="Açıklama giriniz"
                    />
                </div>
                <div class="form-group">
                    <label class="font-weight-bold">Tip</label>
                    <select class="form-control bg-img-none" v-model="editForm.ProjectType">
                        <option value="Kart">Kart</option>
                        <option value="Banka 1">Banka 1</option>
                        <option value="Banka 2">Banka 2</option>
                    </select>
                </div>
                <!-- Borç/Alacak türü değiştirilemez — gösterim amaçlı -->
                <div class="form-group">
                    <label class="font-weight-bold">Hareket Türü</label>
                    <input
                        type="text"
                        class="form-control"
                        :value="editForm.Positive ? 'Alacak' : 'Borç'"
                        readonly
                        disabled
                    />
                    <small class="text-muted">Borç/Alacak türü değiştirilemez.</small>
                </div>
            </b-overlay>
        </b-modal>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from "@/api/employee-operations";
import moment from "moment";
import { BOverlay, BCard, BModal } from "bootstrap-vue";
import VStatsBox from "@/components/VStatsBox.vue";

export default {
    components: {
        BOverlay,
        BCard,
        BModal,
        VStatsBox,
    },
    data() {
        return {
            getting: false,
            saving: false,
            years: [],
            employeeLoading: false,
            employees: [],
            employee: null,
            year: moment().year(),
            details: [],
            totalDebt: "0,00",
            totalCredit: "0,00",
            overall: "0,00",
            editForm: {
                Id: null,
                Amount: null,
                DueDate: null,
                Description: "",
                ProjectType: "Kart",
                Positive: null,
            },
        };
    },
    computed: {
        /**
         * details listesinden ProjectType string değerine ("Kart", "Banka 1", "Banka 2") göre
         * net tutar hesaplar: Alacak toplamı - Borç toplamı.
         * Amount ham decimal alanı kullanılır (AmountStr parse edilmez).
         */
        projectDistribution() {
            const groups = {
                Kart: 0,
                "Banka 1": 0,
                "Banka 2": 0,
            };

            (this.details || []).forEach((d) => {
                const key = d.ProjectType;
                if (key in groups) {
                    const val = d.Positive ? d.Amount : -d.Amount;
                    groups[key] = (groups[key] || 0) + val;
                }
            });

            const toplam = groups["Kart"] + groups["Banka 1"] + groups["Banka 2"];

            return {
                Kart: this.formatAmount(groups["Kart"]),
                Banka1: this.formatAmount(groups["Banka 1"]),
                Banka2: this.formatAmount(groups["Banka 2"]),
                Toplam: this.formatAmount(toplam),
            };
        },
        /**
         * Bakiye = tüm hareketlerin neti (Alacak - Borç).
         * FE'de formatAmount ile üretilir; ₺ işareti ve format diğer kutucuklarla tutarlı olur.
         */
        balanceStr() {
            const net = (this.details || []).reduce((acc, d) => acc + (d.Positive ? d.Amount : -d.Amount), 0);
            return this.formatAmount(net);
        },
    },
    created() {
        const { employeeId, identityNumber, fullName } = this.$route.query;

        if (employeeId && fullName) {
            const preSelectedEmployee = {
                Id: employeeId,
                IdentityNumber: identityNumber,
                FullName: fullName,
                Combine: `${identityNumber || ""} - ${fullName}`,
            };

            this.employee = preSelectedEmployee;
            this.employees = [preSelectedEmployee];
        }
    },
    mounted() {
        this.configureYears();
        if (this.employee && this.employee.Id) {
            this.get();
        }
    },
    methods: {
        searchEmployees(search) {
            if (search) {
                this.employeeLoading = true;
                EmployeeOperationsApi.Employee.Search(search)
                    .then((res) => {
                        this.employees = res.data.Data?.map((e) => ({
                            ...e,
                            Combine: [e.IdentityNumber, e.FullName].join(" - "),
                        }));
                        this.employeeLoading = false;
                    })
                    .catch(() => {
                        this.employeeLoading = false;
                    });
            }
        },
        get() {
            this.getting = true;
            EmployeeOperationsApi.Employee.Balance.Table(this.year, this.employee?.Id)
                .then((res) => {
                    if (res.data.Success) {
                        this.details = res.data.Data.Details;
                        this.totalDebt = res.data.Data.TotalDebtStr || "0,00";
                        this.totalCredit = res.data.Data.TotalCreditStr || "0,00";
                        this.overall = res.data.Data.OverallStr || "0,00";
                    }
                })
                .finally(() => {
                    this.getting = false;
                });
        },
        configureYears() {
            let years = [];
            let year = moment().add(1, "year").format("YYYY");
            let firstYear = 1900;
            while (firstYear <= year) {
                years.push(firstYear++);
            }
            this.years = years.reverse();
        },
        /**
         * Satır kilitli mi?
         * Kural: Borç (Positive == false) VE IsLocked == true ise düzenleme engellenir.
         * NOT: Backend, IsLocked alanını EmployeeBalanceDetailModel'e ekledi (2026-06-16).
         * Eski response'larda IsLocked undefined gelebilir — undefined güvenle false davranır.
         */
        isRowLocked(d) {
            return !d.Positive && !!d.IsLocked;
        },
        openEditModal(d) {
            this.editForm = {
                Id: d.Id,
                // Amount ham decimal — backend'den doğrudan geliyor
                Amount: d.Amount,
                // DueDate: backend ISO string veya ToTMSDate() formatında gelebilir.
                // input[type=date] için yyyy-MM-dd gerekli; moment ile normalize ediyoruz.
                DueDate: d.DueDate
                    ? moment(d.DueDate).format("YYYY-MM-DD")
                    : (d.DueDateStr
                        ? moment(d.DueDateStr, ["DD.MM.YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD")
                        : null),
                Description: d.Description || "",
                ProjectType: d.ProjectType || "Kart",
                Positive: d.Positive,
            };
            this.$bvModal.show("edit-balance-modal");
        },
        resetEditForm() {
            this.editForm = {
                Id: null,
                Amount: null,
                DueDate: null,
                Description: "",
                ProjectType: "Kart",
                Positive: null,
            };
        },
        saveEdit() {
            if (!this.editForm.Id) return;
            if (!this.editForm.Amount || this.editForm.Amount <= 0) {
                this.$bvToast.toast("Tutar 0'dan büyük olmalıdır.", { title: "Hata", variant: "danger" });
                return;
            }

            this.saving = true;

            const payload = {
                Id: this.editForm.Id,
                Amount: this.editForm.Amount,
                DueDate: this.editForm.DueDate
                    ? moment(this.editForm.DueDate, "YYYY-MM-DD").toISOString()
                    : null,
                Description: this.editForm.Description,
                ProjectType: this.editForm.ProjectType,
            };

            EmployeeOperationsApi.Employee.Balance.Update(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.$bvToast.toast("Kayıt başarıyla güncellendi.", { title: "Başarılı", variant: "success" });
                        this.$bvModal.hide("edit-balance-modal");
                        this.get();
                    } else {
                        this.$bvToast.toast(res.data.Message || "Güncelleme başarısız.", { title: "Hata", variant: "danger" });
                    }
                })
                .catch(() => {
                    this.$bvToast.toast("Sunucuya bağlanılamadı.", { title: "Hata", variant: "danger" });
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        /**
         * Net tutarı TL formatlı string'e çevirir.
         * Negatif değerler "-X.XXX,XX ₺" biçiminde gösterilir.
         */
        formatAmount(value) {
            if (value === null || value === undefined) return "0,00 ₺";
            const abs = Math.abs(value);
            const formatted = abs.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return (value < 0 ? "-" : "") + formatted + " ₺";
        },
    },
};
</script>
